module.exports = __webpack_public_path__ + "static/js/locations.2141b073.chunk.worker.js"